import LandingService from '@/api/client/landing.service'

export default {
  state: {
    landing: {},
  },
  getters: {
    landingInfo: state => state.landing,
  },
  actions: {
    async getLandingInfo({ commit }) {
      const response = await LandingService.getLanding()
      commit('setLanding', response)
    },
  },
  mutations: {
    setLanding: (state, landingInfo) => {
      state.landing = landingInfo
    },
  },
}
